import { useQuery } from "react-query";
import axios from "infra/http";
import { TimelineLog } from "components/TimelineLogs";

function useLogsReserva(id: string | undefined) {
  return useQuery(
    `/v1/reserva/${id}/logs`,
    async () => {
      const { data } = await axios.get<TimelineLog[]>(`/v1/reserva/${id}/logs`);

      return data;
    },
    {
      enabled: !!id,
    }
  );
}

export default useLogsReserva;
